import { useEffect, useState } from "react";

interface UseAnimatedPercentagesOptions {
    hasVoted: boolean;
    selectedOption: number | null;
    targetPercentages: [number, number];
    duration?: number;
}

/**
 * 투표 결과 퍼센트 애니메이션 훅
 * VotingCard와 VotingPage에서 공유하는 애니메이션 로직
 */
export const useAnimatedPercentages = ({
    hasVoted,
    selectedOption,
    targetPercentages,
    duration = 800
}: UseAnimatedPercentagesOptions): [number, number] => {
    const [animatedPercentages, setAnimatedPercentages] = useState<
        [number, number]
    >([0, 0]);

    useEffect(() => {
        if (!hasVoted || selectedOption === null) {
            setAnimatedPercentages([0, 0]);
            return;
        }

        const startTime = Date.now();

        const animate = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / duration, 1);

            const easeProgress = 1 - Math.pow(1 - progress, 3);

            const current0 = Math.round(targetPercentages[0] * easeProgress);
            const current1 = Math.round(targetPercentages[1] * easeProgress);

            setAnimatedPercentages([current0, current1]);

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    }, [hasVoted, selectedOption, targetPercentages, duration]);

    return animatedPercentages;
};
